/*global FilterUpdater, Filter */

( function ( $ ) {
    const $categoryDataElement = $('#categoryData'),
        categoryData = $categoryDataElement.length > 0 ? JSON.parse($categoryDataElement.text()) : false;

    if(!categoryData) {
        return;
    }

    let hashQueryString = window.location.hash,
        currentSort = $( '#js-current-sort' ),
        listingHolder = $( '#js-listing-holder' ),
        productContainer = $( '.js-productContainer' ),
        holder = $( '.silk-product-item-holder' ),
        language = categoryData.language,
        search = categoryData.search,
        perPage = parseInt(categoryData.perPage),
        paginationText = categoryData.paginationText,
        currentPage = 1,
        allProducts = $('.products .product').clone(),
        searchHitCountSelector = '.js-hit-count',
        silkForm = $('#silkFilterForm'),
        onPageLoad = false,
        loadMore = {
            $paginationText: $('#js-product-listing-pagination-text'),
            $button: $('#js-product-listing-load-more'),
			$progress: $('#js-product-listing-progress'),
        };

    const filterClasses = {
        'hidden' : 'd-none',
        'active' : 'active',
    }

    if (silkForm.length) {
        init();
    }

    function init() {
        if (silkForm.data('ajaxurl')) {
            filterDataLoad();
        }

        if (hashQueryString != '') {
            $('.silk-spinner').removeClass( filterClasses.hidden );
        }

        let silkHashClear = $('.silk-hash-clear');
        if (silkHashClear.length) {
            silkHashClear.on('click', function (e) {
                e.preventDefault();
                history.pushState( '', document.title, window.location.pathname + window.location.search );
                silkForm.trigger( 'reset' );
                $('.silk-hash-orderby').removeClass( filterClasses.active );
                $('.silk-hash-orderby.default').addClass( filterClasses.active );
                $('.silk-hash-select-item').removeClass( filterClasses.active );
                filterProducts();
            } );
        }

        let silkCustomFilter = $('.silk-custom-filter');
        if (silkCustomFilter.length) {
            silkCustomFilter.on('change', function(){
                if ($(this).data('term') && !$(this).hasClass('js-variant')) {
                    renderVariants($(this).data('term'));
                }
                filterProducts();
            });
        }

        let silkHashSelectItem = $('.silk-hash-select-item');
        if (silkHashSelectItem.length) {
            silkHashSelectItem.on('click', function ( e ) {
                e.preventDefault();
                const _this = $(this);
                const parent = _this.parents('.silk-hash-select');

                if (parent) {
                    parent.find('.silk-hash-select-item').removeClass( filterClasses.active );
                    parent.find('.silk-hash-select-label').text( _this.text() );
                    _this.addClass( filterClasses.active );
                    filterProducts();
                }
            } );
        }

        let silkHashOrderby = $('.silk-hash-orderby');
        if (silkHashOrderby.length) {
            silkHashOrderby.on('click', function ( e ) {
                e.preventDefault();
                $('.silk-hash-orderby.active').removeClass( filterClasses.active );
                $(this).addClass( filterClasses.active );
                if( $(this).data('value') == 'price_asc' || $(this).data('value') == 'price_desc' ) {
                    $(this).closest('.js-sort-custom-container').find('button.dropdown-toggle').addClass( filterClasses.active );
                } else {
                    $(this).closest('.js-filter-accordion-body').find('.js-sort-custom-container').find('button.dropdown-toggle').removeClass( filterClasses.active );
                }
                currentSort.text( $( this ).text() );
                filterProducts();
            } );
        }

        let silkHashFilter = $('.silk-hash-filter');
        if (silkHashFilter.length) {
            silkHashFilter.on('click', function () {
                filterProducts();
            });
        }

        loadMore.$button.on('click', function () {
            silkProductLoad( ++currentPage );
        });
    }

    function filterProducts() {

        var colorList = '';
        var sizeList = '';
        var categoryList = '';
        var variantList = '';
        var materialList = '';

        var orderBy = $( '.silk-hash-orderby.active' ).data( 'value' ) ? $( '.silk-hash-orderby.active' ).data( 'value' ) : '';
        var collection = '';
        var price = '';
        var comma = '';

        $('.silk-hash-select').each( function () {
            var selectName = $(this).data('name');
            var selectValue = $(this).find('.silk-hash-select-item.active').data('value');
            if ( selectValue ) {
                switch ( selectName ) {
                    case 'price':
                        price = selectValue;
                        priceFilter += selectName;
                        break;

                    case 'collection':
                        collection = selectValue;
                        collectionFilter += selectName;
                        break;
                }
            }
        } );

        $('.silk-hash-filter').each( function () {
            var inputName = $( this ).attr( 'name' );
            var inputValue = $( this ).val();
            if ( $( this ).prop( 'checked' ) == true ) {
                switch ( inputName ) {
                    case 'color':
                        comma = '';
                        if ( colorList != '' ) {
                            comma = ',';
                        }
                        colorList += comma + inputValue;
                        break;
                    case 'size':
                        comma = '';
                        if ( sizeList != '' ) {
                            comma = '|';
                        }
                        sizeList += comma + inputValue;
                        break;
                    case 'category':
                        comma = '';
                        if ( categoryList != '' ) {
                            comma = ',';
                        }
                        categoryList += comma + inputValue;
                        break;
                    case 'variant':
                        comma = '';
                        if ( variantList != '' ) {
                            comma = ',';
                        }
                        variantList += comma + inputValue;
                        break;
                    case 'material':
                        comma = '';
                        if ( materialList != '' ) {
                            comma = '|';
                        }
                        materialList += comma + inputValue;
                        break;
                }
            }
        } );

        var filterUrl = '';

        if ( categoryList != '' ) {
            filterUrl += 'category=' + categoryList;
        } else if(categoryData.currentCategory) {
            filterUrl += 'category=' + categoryData.currentCategory;
        }

        if ( colorList != '' ) {
            if ( filterUrl != '' ) {
                filterUrl += '&';
            }
            filterUrl += 'color=' + colorList;
            var colorFilter = new RegExp( colorList.replace(/,/g, '|'), 'g');
        }

        if ( sizeList != '' ) {
            if ( filterUrl != '' ) {
                filterUrl += '&';
            }
            filterUrl += 'size=' + sizeList;
            var sizeFilter = new RegExp( sizeList.replace(/,/g, '|'), 'g');
        }
        if ( materialList != '' ) {
            if ( filterUrl != '' ) {
                filterUrl += '&';
            }
            filterUrl += 'material=' + materialList;
            var materialFilter = new RegExp( materialList.replace(/,/g, '|'), 'g');
        }
        if ( orderBy != '' && typeof orderBy !== 'undefined' ) {
            if ( filterUrl != '' ) {
                filterUrl += '&';
            }
            filterUrl += 'orderBy=' + orderBy;
        }
        if ( price != '' && typeof price !== 'undefined' ) {
            if ( filterUrl != '' ) {
                filterUrl += '&';
            }
            filterUrl += 'price=' + price;
            var priceFilter = price;
        }
        if ( collection != '' && typeof collection !== 'undefined' ) {
            if ( filterUrl != '' ) {
                filterUrl += '&';
            }
            filterUrl += 'collection=' + collection;
            var collectionFilter = new RegExp( collection.replace(/,/g, '|'), 'g');
        }
        if ( variantList != '' && typeof variantList !== 'undefined' ) {
            if ( filterUrl != '' ) {
                filterUrl += '&';
            }
            filterUrl += 'variant=' + variantList;
            var variantFilter = new RegExp( variantList.replace(/,/g, '|'), 'g');
        }

        filterUrl = '#' + filterUrl;
        window.history.pushState( '', 'Title', filterUrl );

        var categoryFilter;

        if ( categoryList != '' ) {
            categoryFilter = new RegExp( categoryList.replace(/,/g, '|'), 'g');
        } else {
            categoryFilter = new RegExp( categoryData.currentCategory, 'g');
        }

        $('.products .product').remove();

        var filteredResult = '';

        filteredResult = allProducts.filter(function () { return $(this).data('category') ? $(this).data('category').match(categoryFilter) : false } ).clone();

        FilterUpdater.update(filteredResult, allProducts);
        Filter.dropdownUpdate();

        if( variantFilter ) {
            filteredResult = filteredResult.filter(function () { return $(this).data('variant') ? $(this).data('variant').match(variantFilter) : false } );
        }
        if( colorFilter ) {
            filteredResult = filteredResult.filter(function () { return $(this).data('color') ? $(this).data('color').match(colorFilter) : false } );
        }
        if( sizeFilter ) {
            filteredResult = filteredResult.filter(function () { return $(this).data('size') ? $(this).data('size').toString().match(sizeFilter) : false } );
        }
        if( materialFilter ) {
            filteredResult = filteredResult.filter(function () { return $(this).data('material') ? $(this).data('material').match(materialFilter) : false } );
        }

        if( collectionFilter ) {
            filteredResult = filteredResult.filter(function () { return $(this).data('collection') ? $(this).data('collection').match(collectionFilter) : false } );
        }

        if( priceFilter ) {
            let range = priceFilter.split('-');
            let start = range[0];
            let end = range[1] !== 'above' ? range[1] : null;

            filteredResult = filteredResult.filter(function () {
                let price = parseInt($(this).data('price'), 10);
                if (!end) {
                    return price >= parseInt(start, 10);
                } else {
                    return price >= parseInt(start, 10) && price <= parseInt(end, 10);
                }
            });
        }

        // Sort results
        filteredResult = sortProducts(filteredResult, orderBy);

        // Render product items
        appendProducts(filteredResult);

        // START REMOVE MASONRY
        // if( typeof window.productsMasonry !== 'undefined' ) {
        //     // Rebuild masonry
        //     window.productsMasonry.masonry( 'destroy' );
        //     window.productsMasonry.masonry( {
        //         itemSelector: '.product',
        //         percentPosition: true,
        //     } );
        // }

        // Reinitialize read more link
        // window.titleCardCollapse();
         // END REMOVE MASONRY

        window.lazyLoadInstance.update();

        // Filter tag listener
        filterTagInit();

        // Show Product Bg
        if ( $( '.bg-image' ).hasClass( filterClasses.hidden ) ) {
            $( '.bg-image' ).removeClass( filterClasses.hidden );
        }

        // Remove 2nd product image for hover if in mobile view
        var currentIsDesktop = matchMedia( 'screen and (min-width: 992px)' ).matches;
        if (currentIsDesktop === false) {
            var productImages = $( '.products .product figure img' );

            if (productImages.length > 0) {
                $.each( productImages, function() {
                    if ($(this).hasClass( 'second-image' )) {
                        $(this).parent().removeClass( 'has-second-image' );
                        $(this).remove();
                    }
                } );
            }
        }

        // Update hit count
        if ($( searchHitCountSelector ).length) {
            $.each( $( searchHitCountSelector ), function() {
                $(this).text( filteredResult.length );
            } );
        }

        currentPage = 1;
        updateLoadMore();
    }

    function renderVariants (term) {
        let variants = $('.js-variants');
        let itemSelector = '.js-variant';

        if (!variants.length) return;

        if (onPageLoad === false) {
            variants.find( itemSelector ).removeClass( filterClasses.active ).addClass( filterClasses.hidden );
            variants.find( itemSelector+ ' input[name="variant"]' ).prop('checked', false);
        }

        if (!term && $('.silk-hash-filter[name="category"]').prop('checked')) {
            term = $('.silk-hash-filter[name="category"]').parent().data('term');
        }

        if (term && typeof(term) !== 'undefined' && variants.find( itemSelector+'[data-term="'+ term +'"]' )) {
            variants.find( itemSelector ).addClass( filterClasses.hidden );
            variants.find( itemSelector+'[data-term="'+ term +'"]' ).removeClass( filterClasses.hidden );
        } else if (!term || typeof(term) === 'undefined') {
            variants.find( itemSelector ).removeClass( filterClasses.hidden );
        }

        if (variants.find( itemSelector ).length === variants.find( itemSelector+'.'+filterClasses.hidden ).length) {
            variants.addClass( filterClasses.hidden );
        } else {
            variants.removeClass( filterClasses.hidden );
        }
    }

    function sortProducts (filteredResult, orderBy) {
        var sortTitleDesc = function(a,b) {
            a = $(a).data('name').toUpperCase();
            b = $(b).data('name').toUpperCase();
            if(a > b) {
                return -1;
            } else if(a < b) {
                return 1;
            } else {
                return 0;
            }
        };

        var sortTitleAsc = function(a,b) {
            a = $(a).data('name').toUpperCase();
            b = $(b).data('name').toUpperCase();
            if(a < b) {
                return -1;
            } else if(a > b) {
                return 1;
            } else {
                return 0;
            }
        };

        var sortPrizeDesc = function(a,b) {
            a = parseInt($(a).data('prize'), 10);
            b = parseInt($(b).data('prize'), 10);
            if(a > b) {
                return -1;
            } else if(a < b) {
                return 1;
            } else {
                return 0;
            }
        };

        var sortPrizeAsc = function(a,b) {
            a = parseInt($(a).data('prize'), 10);
            b = parseInt($(b).data('prize'), 10);
            if(a < b) {
                return -1;
            } else if(a > b) {
                return 1;
            } else {
                return 0;
            }
        };

        var sortIndexAsc = function(a,b) {
            a = parseInt($(a).data('index'), 10);
            b = parseInt($(b).data('index'), 10);
            if(a < b) {
                return -1;
            } else if(a > b) {
                return 1;
            } else {
                return 0;
            }
        };

        var sortNewest = function ( a, b ) {
            a = parseInt( $( a ).data( 'new' ), 10 );
            b = parseInt( $( b ).data( 'new' ), 10 );
            if ( a > b ) {
              return -1;
            } else if ( a < b ) {
              return 1;
            } else {
              return 0;
            }
        };

        switch ( orderBy ) {
            case 'price_asc':
                filteredResult = filteredResult.sort(sortPrizeAsc);
                break;
            case 'price_desc':
                filteredResult = filteredResult.sort(sortPrizeDesc);
                break;
            case 'title_desc':
                filteredResult = filteredResult.sort(sortTitleDesc);
                break;
            case 'title_asc':
                filteredResult = filteredResult.sort(sortTitleAsc);
                break;
            case 'newest':
                filteredResult = filteredResult.sort(sortNewest);
                break;
            case 'popular':
                filteredResult = filteredResult.sort(sortIndexAsc);
                break;
        }

        return filteredResult;
    }

    function filterDataLoad () {
        var ajaxUrl = $( '#silkFilterForm' ).data( 'ajaxurl' );
        var currentCategory = categoryData.currentCategory;
        var currentTaxonomy = categoryData.currentTaxonomy;
        var currentTermId = categoryData.currentTermId;

        if (currentCategory && currentTermId) {
            ajaxUrl += '&category=' + currentCategory + '&termid=' + currentTermId;
        }

        if (currentCategory && currentTermId) {
            ajaxUrl += '&taxonomy=' + currentTaxonomy;
        }

        if ( search ) {
            ajaxUrl += '&search=' + encodeURIComponent( search );
        }

        ajaxUrl = ajaxUrl.replace(/per_page=[\d]{1,4}/,'per_page=1000');

        $.ajax( {
            url: ajaxUrl + '&lang=' + language,
            type: 'GET',
            async: true,
            error: function ( data, textStatus ) {
                console.log( data );
                console.log( textStatus );
            },
            success: function ( data ) {
                var orderBy = '';
                if ( search ) {
                    orderBy = $('.silk-hash-orderby.active').data('value') ? $( '.silk-hash-orderby.active' ).data( 'value' ) : '';
                } else {
                    orderBy = $('.silk-hash-orderby.active').data('value') ? $( '.silk-hash-orderby.active' ).data( 'value' ) : 'popular';
                }

                var html = '';

                if ( $( data ).length > 0 ) {
                    html = '';

                    $( '.silk-spinner' ).addClass( filterClasses.hidden );

                    $( data ).each( function ( _, val ) {
                        html += val.product_item.replace(/(\r\n|\n|\r)/gm, '');
                    } );

                    allProducts = $( html ).clone();

                    if ( hashQueryString != '' ) {

                        silkSetFilterUsingHash();
                        filterProducts();

                        // update variant
                        onPageLoad = true;
                        renderVariants();

                    } else {
                        let filteredResult = sortProducts( $(html), orderBy );
                        appendProducts(filteredResult);

                        // START REMOVE MASONRY
                        // Rebuild masonry
                        // if( typeof window.productsMasonry !== 'undefined' ) {
                        //     window.productsMasonry.masonry( 'destroy' );
                        //     window.productsMasonry.masonry( {
                        //         itemSelector: '.product',
                        //         percentPosition: true,
                        //     } );
                        //     window.productsMasonry.masonry('reloadItems');
                        // }

                        // // Reinitialize read more link
                        // window.titleCardCollapse();
                        // END REMOVE MASONRY

                        window.lazyLoadInstance.update();

                        FilterUpdater.update(filteredResult, allProducts);

                        // Update hit count
                        if ($( searchHitCountSelector ).length) {
                            $.each( $( searchHitCountSelector ), function() {
                                $(this).html( $( data ).length );
                            } );
                        }

                        // Show Product Bg
                        if ( $( '.bg-image' ).hasClass( filterClasses.hidden ) ) {
                            $( '.bg-image' ).removeClass( filterClasses.hidden );
                        }
                    }

                } else {
                    holder.html( '<p>' + holder.data( 'alt' ) + '</p>' );
                }

                onPageLoad = false;
                updateLoadMore();
            },
            complete: function () {
                // Show product listing
                listingHolder.removeClass( 'invisible' );
                showLoader( false );
            },
        } );
    }

    function updateLoadMore() {
        const allProducts = productContainer.find('.product'),
			visibleProducts = productContainer.find('.product:visible');

        loadMore.$paginationText.text(
            paginationText
                .replace('[current]', visibleProducts.length)
                .replace('[total]', allProducts.length)
        );
		loadMore.$progress.css('width', ((visibleProducts.length / allProducts.length) * 100) + '%');
		loadMore.$progress.parent().show();
        Math.ceil(allProducts.length / perPage) === currentPage ? loadMore.$button.hide() : loadMore.$button.show();
    }

    function appendProducts(products) {
        if (!productContainer.length || !products) {
            return;
        }

        productContainer.empty();
        productContainer.each( function() {
            const start = $(this).data('start');
            const end = $(this).data('end');

            let targetContainer = $(this),
                items = [];

            $.each(products,function( pos, item ) {
                if (!item) return;

                let index = pos+1;

                // Paginate the results
                if(pos >= perPage) {
                    if (item.classList) {
                        item.classList.add(filterClasses.hidden);
                    } else {
                        item.className += ` ${filterClasses.hidden}`;
                    }
                }

                if (parseInt(index) >= parseInt(start) && parseInt(index) <= parseInt(end)) {
                    items.push(item);
                }
            });

            targetContainer.append(items);

            if (targetContainer.children().length) {
                targetContainer.parent().removeClass( filterClasses.hidden );
            } else {
                targetContainer.parent().addClass( filterClasses.hidden );
            }
        });

        // START REMOVE MASONRY
        // Rebuild masonry
        // if( typeof window.productsMasonry !== 'undefined' ) {
        //     window.productsMasonry.masonry( 'destroy' );
        //     window.productsMasonry.masonry( {
        //         itemSelector: '.product',
        //         percentPosition: true,
        //     } );
        // }
        // END REMOVE MASONRY

    }

    function silkProductLoad( nextPage ) {
        $.each($('.products .product'),function( pos, item ) {
            if(pos >= perPage * nextPage) {
                item.classList.add(filterClasses.hidden);
            } else {
                item.classList.remove(filterClasses.hidden);
            }
        });

        currentPage = nextPage;

        // Rebuild masonry
        // window.productsMasonry.masonry( 'layout' );

        // Reinitialize read more link
        // window.titleCardCollapse();
        // END REMOVE MASONRY

        window.lazyLoadInstance.update();

        // Show Product Bg
        if ( $( '.bg-image' ).hasClass( filterClasses.hidden ) ) {
            $( '.bg-image' ).removeClass( filterClasses.hidden );
        }

        updateLoadMore();
    }

    function silkSetFilterUsingHash () {
        var hash = window.location.hash;
        hash = decodeURI(hash.replace( '#', '' ));
        var hashArr = hash.split( '&' );
        if ( hashArr.length > 0 ) {
            $( hashArr ).each( function ( key, queryItem ) {
                var queryItemArr = queryItem.split( '=' );
                if ( queryItemArr.length > 0 ) {
                    $( queryItemArr ).each( function ( queryItemKey, queryItemValue ) {
                        var queryItemValueArr = queryItemValue.split( ',' );

                        if ( queryItemValue.indexOf( '|' ) !== -1 ) {
                            queryItemValueArr = queryItemValue.split( '|' );
                        }

                        if ( queryItemValueArr.length > 0 ) {
                            $( queryItemValueArr ).each( function ( queryItemSelectedKey, queryItemSelectedValue ) {
                                if ( queryItemSelectedValue != '' ) {
                                    const inputName = queryItemArr[0];
                                    queryItemSelectedValue = decodeURIComponent(queryItemSelectedValue);

                                    if ( inputName == 'orderBy' ) {
                                        const currentSortField = $( 'a[data-value=' + queryItemSelectedValue + ']' );
                                        $( '.silk-hash-orderby.active' ).removeClass( filterClasses.active );
                                        currentSortField.addClass( filterClasses.active );
                                        currentSort.text( currentSortField.text() );

                                    } else if ($.inArray(inputName, ['collection', 'price']) !== -1) {
                                        const selectedField = $('.silk-hash-select .silk-hash-select-item[data-value=' + queryItemSelectedValue + ']');
                                        const selectedFieldParent = selectedField.parents('.silk-hash-select');

                                        if (selectedFieldParent) {
                                            selectedFieldParent.find('.silk-hash-select-item').removeClass( filterClasses.active );
                                            selectedFieldParent.find('.silk-hash-select-label').text( selectedField.text() );
                                            selectedField.addClass( filterClasses.active );
                                        }
                                    } else {
                                        const currentField = $( 'input[name="' + inputName + '"][value="' + queryItemSelectedValue + '"]' );
                                        if (currentField.length > 0) {
                                            currentField.prop( 'checked', true );

                                            if (currentField.parent().hasClass('silk-custom-filter')) {
                                                currentField.parent().addClass( filterClasses.active );
                                            }
                                        }

                                    }
                                }
                            } );
                        }
                    } );
                }
            } );
        }
    }

    function filterTagInit() {
        var filterTags = $('.silk-filter-tags');
        filterTags.find('.js-filter-tag').remove();
        filterTags.find('.js-filter-tag-bundle').remove();
        var colorFilterValues = [], colorFilterLabel = '';
        var sizeFilterValues = [], sizeFilterLabel = '';
        var categoryFilterValues = [], categoryFilterLabel = '';

        $('.silk-hash-filter').each( function () {
            var inputName = $(this).attr('name');
            var inputValue = $(this).val();
            if ( inputName !== 'orderBy' && $(this).prop('checked') === false )
                return;
            if( inputName === 'orderBy' && !$(this).hasClass('active') )
                return;
            switch ( inputName ) {
                case 'color':
                    colorFilterValues.push(inputValue);
                    colorFilterLabel = $(this).closest('.product-filter-dropdown').find('.js-filter-accordion-toggle').text();
                    break;
                case 'size':
                    sizeFilterValues.push(inputValue);
                    sizeFilterLabel = $(this).closest('.product-filter-dropdown').find('.js-filter-accordion-toggle').text();
                    break;
                case 'category':
                    categoryFilterValues.push(inputValue);
                    categoryFilterLabel = $(this).closest('.product-filter-dropdown').find('.js-filter-accordion-toggle').text();
                    break;
                case 'orderBy':
                    renderFilterTag($(this).closest('.js-sort-orderby-container').find('label').html(), inputValue, inputName);
                    break;
            }
        });
        if( colorFilterValues.length > 0 ) {
            renderFilterTagBundle( colorFilterLabel + ' (' + colorFilterValues.length + ')', 'color', colorFilterValues );
        }
        if( sizeFilterValues.length > 0 ) {
            renderFilterTagBundle( sizeFilterLabel + ' (' + sizeFilterValues.length + ')', 'size', sizeFilterValues );
        }
        if( categoryFilterValues.length > 0 ) {
            renderFilterTagBundle( categoryFilterLabel + ' (' + categoryFilterValues.length + ')', 'category', categoryFilterValues );
        }

        if ($('.js-filter-tag').length === 0 && $('.js-filter-tag-bundle').length === 0) {
			filterTags.find('.silk-hash-clear').addClass(filterClasses.hidden);
			$('.js-silk-filter').attr('style', 'display:none!important')
        } else {
			filterTags.find('.silk-hash-clear').removeClass(filterClasses.hidden);
			$('.js-silk-filter').attr('style', '');
		}

        filterTagListener();
        filterTagListenerBundle();
    }

    function renderFilterTag(name, value, type) {
        var filterTags = $('.silk-filter-tags');

        if (filterTags.length === 0) return;

        var clearTag = filterTags.find('.js-silk-filter-tags');
        var label = name;

        if (type.indexOf('size_') > -1) {
            label = type.replace('size_', '').toUpperCase() + ' ' + name;
        } else if (type === 'size') {
            label = name;
        }
        if (filterTags.find('.js-filter-tag[data-value="'+ value +'"]')) {
            var tag = '<div class="tag js-filter-tag btn btn-sm btn-tersiary" data-value="'+ value +'" data-name="'+ type +'">'+
                label +
            '</div>';

            clearTag.prepend(tag);
        }
    }

    function renderFilterTagBundle(label, type, values) {
        var filterTags = $('.silk-filter-tags');

        if (filterTags.length === 0) return;

        var clearTag = filterTags.find('.js-silk-filter-tags');

        if (filterTags.find('.js-filter-tag-bundle[data-name="'+ type +'"]')) {
            if( filterTags.find('.js-filter-tag-bundle[data-name="'+ type +'"]').length > 0 ) {
                filterTags.find('.js-filter-tag-bundle[data-name="'+ type +'"]').remove();
            }
            var tag = '<div class="tag js-filter-tag-bundle btn btn-sm btn-tersiary" data-name="'+ type +'" data-values="'+values+'">'+
                label +
            '</div>';
            clearTag.prepend(tag);
        }
    }

    function filterTagListener() {
        var filterTags = $(document).find('.js-filter-tag');

        if (filterTags.length === 0) return;

        filterTags.on('click', function() {
            if( $(this).data('name') == 'orderBy' ) {
                $('#silkFilterForm').find('input[name="' + $(this).data('name') + '"]').removeClass('active');
                filterProducts();
            } else {
                $('#silkFilterForm').find('input[name="' + $(this).data('name') + '"][value="' + $(this).data('value') + '"]').trigger('click');
            }

            $(this).remove();
        });
    }

    function filterTagListenerBundle() {
        var filterTags = $(document).find('.js-filter-tag-bundle');

        if (filterTags.length === 0) return;

        filterTags.on('click', function() {
            var $this = $(this);
            var name = $this.data('name');
            var values = $this.data('values').split(',');
            var findString = '';

            $.each(values, function( index, value ) {
                var withComma = ( index > 0 ) ? ',' : '';
                findString += withComma + 'input[name="' + name + '"][value="' + value + '"]';
            });

            $('#silkFilterForm').find(findString).trigger('click');
            $('.silk-filter-tags').find('.js-filter-tag-bundle[data-name="'+ name +'"]').remove();
        });
    }

    function showLoader ( showLoader ) {
        var loader = $( document ).find( '.js-loader' );
        var hiddenClass = 'd-none';

        if ( !loader ) {
            return;
        }

        if ( showLoader ) {
            loader.removeClass( hiddenClass );
        } else {
            loader.addClass( hiddenClass );
        }
    }

    var h1Desktop = document.getElementById( 'js-desktop-h1' ),
        h1Mobile = document.getElementById( 'js-mobile-h1' ),
        isDesktop = true,
        timeOut = false;

    if ( !h1Desktop || !h1Mobile ) {
        return;
    }

    var checkH1 = function () {
        var currentIsDesktop = matchMedia( 'screen and (min-width: 992px)' ).matches;

        if ( isDesktop !== currentIsDesktop ) {
            $( '.js-dynamic-title' ).remove();

            if ( currentIsDesktop ) {
                $( h1Desktop ).after( unescape( h1Desktop.innerText ) );
            } else {
                $( h1Mobile ).after( unescape( h1Mobile.innerText ) );
            }
        }

        isDesktop = currentIsDesktop;
    };

    checkH1();
    $( window ).on('resize', function () {
        if ( timeOut ) {
            clearTimeout( timeOut );
        }

        timeOut = setTimeout( function () {
            checkH1();
        }, 100 );
    } );
} )( jQuery );



// WEBPACK FOOTER //
// ./scripts/components/category.js